import React from "react";
import {
  ComposedChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { RESULT_SOLUTIONS } from "../../lib/results";

export default function SolutionsSatisfactionChart() {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <ComposedChart
        layout="vertical"
        data={RESULT_SOLUTIONS}
        margin={{
          top: 20,
          right: 20,
          bottom: 20,
          left: 20,
        }}
      >
        <CartesianGrid stroke="#f5f5f5" />
        <XAxis
          type="number"
          dataKey="score"
          allowDecimals={true}
          domain={[1.0, 5.0]}
          ticks={[1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0]}
        />
        <YAxis type="category" dataKey="name" width={150} />
        <Tooltip />
        <Bar
          dataKey="score"
          barSize={20}
          fill="#5b82c2"
          label={{ position: "right", fill: "#2d2d2d", fontWeight: "bold" }}
        />
      </ComposedChart>
    </ResponsiveContainer>
  );
}
